<template>
	<div id="jb-calendar">
		<Events />
	</div>
</template>

<script>
// import moment from "moment";
import Events from "./components/events.vue";
import { mapActions, mapGetters } from "vuex";

export default {
	name: "app",
	components: {
		Events
	},
	created: function() {
		// var currentDate = this.$store.state.currentDate[0];
		var dates = {};
		dates.start = this.$store.state.currentDate[0];
		// .format("YYYYMMDD");
		dates.end = this.$store.state.currentDate[1];
		// .format("YYYYMMDD");

		this.loadEvents(dates);
	},
	computed: mapGetters(["allEvents"]),
	methods: {
		...mapActions(["loadEvents"])
	}
};
</script>

<style lang="scss">
#jb-calendar {
}
</style>
